import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShowPromoComponent } from './components/show-promo/show-promo.component';
import { MainComponent } from './components/main/main.component';
import { ShowContactComponent } from './components/show-contact/show-contact.component';
import {CardPromosComponent} from './components/card-promos/card-promos.component';
import {NearPromosComponent} from './components/near-promos/near-promos.component';
import {CampPromosComponent} from './components/camp-promos/camp-promos.component';
import {ShowPromoCampComponent} from './components/show-promo-camp/show-promo-camp.component';


const routes: Routes = [
  {path: '', component: MainComponent},
  {path: 'init/:idCard/:page', component: MainComponent},
  {path: 'showPromo/:idPromo', component: ShowPromoComponent},
  {path: 'showContact', component: ShowContactComponent},
  {path: 'showPromo/:idPromo/:idCard/:page', component: ShowPromoComponent},
  {path: 'showPromoCamp/:idPromo/:idCamp/:page', component: ShowPromoCampComponent},
  {path: 'cardPromos/:cardId/:page', component: CardPromosComponent},
  {path: ':cardName', component: CardPromosComponent},
  {path: 'nearByPromos/:cardId/:page', component: NearPromosComponent},
  {path: 'showCampaign/:idCamp/:page', component: CampPromosComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
